import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewChecked, AfterViewInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'logo-row',
    templateUrl: 'logo-row.template.html',
    styleUrls: ['logo-row.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoRow {
    @Input() item: any;
    @Input() layout: string = "container";
    

    public carouselConfig = {
        showLogo: true,
        showCopy: false,
        showTitle: false,
        viewSlides: 5,
        spacing: 1,
        style: 'logo-carousel',
        centered: false,
        cellStyle: 'logo',
        clickEnable: true,
        backEffect: true,
        loop: false,
        loopAdditionalSlides: 5,
        noLazy: false
    };

    constructor(
        private coreEffects: CoreEffects,
        private route: ActivatedRoute,
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo,
        @Inject(APP_SETTINGS) private settings: Object
    ) { }

    ngOnInit() {

        if(this.deviceInfo.isPhone){
            this.carouselConfig.loop = true;
            this.carouselConfig.centered = true;
            this.carouselConfig.viewSlides = 1;
            this.carouselConfig.backEffect = false;
            this.carouselConfig.loopAdditionalSlides = 1;
            this.carouselConfig.noLazy = true;
        }
    }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/logo-row/logo-row.component.ts